import { phoneNumberNoFormatting } from 'packages/signup/helpers/validateSurvey';
import type { FormDetailsValues } from 'packages/signup/components/signupForm/types';
import type { LeadFormDetailsValues } from 'components/company_leads/lead_form_v2/types';

export const sendDataWithouFormatDemoLead = (leadForm: LeadFormDetailsValues) => {
  return {
    companyName: leadForm.companyName,
    email: leadForm.email,
    firstName: leadForm.firstName,
    lastName: leadForm.lastName,
    industry: leadForm.industry,
    numberEmployees: leadForm.numberEmployees,
    phone: phoneNumberNoFormatting(leadForm.phone),
  };
};

export default function sendDataWithoutFormatToPayload(companyLead: FormDetailsValues) {
  return {
    firstName: companyLead.firstName,
    lastName: companyLead.lastName,
    email: companyLead.email,
    companyName: companyLead.companyName,
    numberEmployees: companyLead.numberEmployees,
    phone: phoneNumberNoFormatting(companyLead.phone),
    password: companyLead.password,
    passwordConfirmation: companyLead.passwordConfirmation,
  };
}
